import {
  Directive, EventEmitter, HostListener, Input, Output, inject,
} from '@angular/core';
import { ToastOptions } from '@ionic/angular';
import { ToastService } from 'src/app/@core/toast.service';

@Directive({
  selector: '[conditionalClick]',
  standalone: false,
})
export class ConditionalClickDirective {
  @Input() public condition: boolean;
  @Input() public conditionalMessage: string = '';
  @Input() public conditionalToastOptions: ToastOptions = {
    color: 'danger',
  };

  @Output() public conditionalClick: EventEmitter<Event> = new EventEmitter<Event>();

  private toastService = inject(ToastService);

  @HostListener('click', ['$event'])
  public onClick(event: CustomEvent): Promise<void> {
    event.stopPropagation();

    if (this.condition) {
      this.conditionalClick.emit(event);

      return Promise.resolve();
    }

    return this.toastService.show(this.conditionalMessage, this.conditionalToastOptions);
  }
}
